import React from "react";

function NotFound() {
  return <h1>404: NOt found</h1>;
}

export default NotFound;
